'use client';

export { default } from './Box';
export { default as boxClasses } from './boxClasses';
export * from './boxClasses';